import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { InvoiceTemplate } from 'src/admin-entity/interface/setting/invoice-template.zod';
import { InvoiceTopicItem } from 'src/admin-entity/interface/setting/invoice-topic-item.zod';

export interface SettingInitType {
    invoiceTemplate: {
        template: InvoiceTemplate;
        searchCondition: {
            page: number;
            take: number;
            title: string;
        };
        templateList: Page<InvoiceTemplate>;
        topicItemList: InvoiceTopicItem[];
        selectedTopicItemList: InvoiceTopicItem[];
        appliedTopicItemList: InvoiceTopicItem[];
        selectedAppliedTopicItemList: InvoiceTopicItem[];
    };
}

export const initialState: SettingInitType = {
    invoiceTemplate: {
        template: {
            id: 0,
            title: '',
            fields: [],
        },
        searchCondition: {
            page: 0,
            take: 10,
            title: '',
        },
        templateList: {
            list: [],
            page: {
                count: 0,
            },
        },
        topicItemList: [],
        selectedTopicItemList: [],
        appliedTopicItemList: [],
        selectedAppliedTopicItemList: [],
    },
};
